import { render, staticRenderFns } from "./BlockedEmailFormCreate.vue?vue&type=template&id=436edc2d&lang=pug"
import script from "./BlockedEmailFormCreate.vue?vue&type=script&lang=js"
export * from "./BlockedEmailFormCreate.vue?vue&type=script&lang=js"
import style0 from "./BlockedEmailFormCreate.vue?vue&type=style&index=0&id=436edc2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports